import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDoubleCheckmark1"><Path d="M2.5 12.8036L7.85714 19.5L17.5 4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.7502 19.75L21.5 4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDoubleCheckmark1;
